
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Component, Inject} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from '../env.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';



export interface DialogData {
  custId: string;
}

@Component({
  selector: 'user-verification-dialog',
  templateUrl: 'verify.component.html',
})
export class UserVerificationDialog {

  userOtp = '';

  constructor( private http: HttpClient, private env: EnvService, private router: Router, private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<UserVerificationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  showPassword = false;

  getInputType() {
    if (this.showPassword) {
      return 'text';
    }
    return 'password';
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  openSnackBar(msg) {
    this._snackBar.open(msg, '', {
      duration: 2000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
    });
  }

  sendEmail() {
    this.http.post(this.env.apiUrl + "/api/user/sendEmailWithOtp", {custId: this.data.custId})
    .subscribe(response => {
      console.log(response);
      this.openSnackBar(response['message']);
    }, err => {
      console.log(err);
      this.openSnackBar("Failed to send email.");
    })
  }

  verifyOtpReceived() {
    this.http.post(this.env.apiUrl + "/api/user/verifyUserOtp", {custId: this.data.custId, otp: this.userOtp})
    .subscribe(response => {
      console.log(response);
      this.openSnackBar("Verified successfully.");
      this.dialogRef.close();
      setTimeout(() => {
        window.location.reload();
        // this.router.navigate(['home']);
      }, 1250);
    }, err => {
      console.log(err);
      this.openSnackBar("Failed otp verification.");
    })
  }

}
